import React, { FC, useCallback, useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import {
  ListFilter,
  createMultiSelectFilter,
  createSelectFilter,
} from '../../../../../Components/ListFilter/ListFilter';
import { UserContext } from '../../../../../Context/UserContext/UserContext';
import { useAptorApi, useFetchFilterOptions } from '../../../../../Api';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import { entityToSelectlebelOption, OptionsEntity } from '../../../../../Utilities';
import { updateFilterOptionsDependentOnCompanyUnit } from '../../../../../Components/ListFilter/filterUtils';
import { INamedEntity } from '../../../../../Api/AptorApi';

interface IOptions extends OptionsEntity {
  areas: SelectOption[];
  companyUnits: SelectOption[];
  complianceUsers: SelectOption[];
  processes: SelectOption[];
  aspects: SelectOption[];
  tags: SelectOption[];
}

interface IProps {
  companyUnit?: INamedEntity;
  filters: any;
  setFilter: (field: string, values: string[] | { min?: Date; max?: Date } | undefined) => void;
  disable?:boolean;
}

export const RequirementsListFilter: FC<IProps> = ({ companyUnit, filters, setFilter,disable }) => {
  const { api, abortController } = useAptorApi();
  const { formatMessage } = useIntl();
  const { getCompanyUnitName, getProcessName, getAspectName, getTagName } = useContext(UserContext);
  const [allOptions, , , userCompanyUnits] = useFetchFilterOptions<IOptions>(
    useCallback(() => api.getOrganizationRequirementFilters(), [api]),
    abortController,
  );

  const [options, setOptions] = useState<IOptions | null>(null);

  useEffect(() => {
    setOptions(allOptions);
  }, [allOptions]);

  const onSetFilter = (field: string, values: string[] | { min?: Date; max?: Date } | undefined) => {
    setFilter(field, values);
    updateFilterOptionsDependentOnCompanyUnit(
      field,
      values,
      setOptions,
      allOptions,
      filters,
      setFilter,
      userCompanyUnits,
    );
  };

  useEffect(() => {
    if (allOptions && companyUnit) {
      updateFilterOptionsDependentOnCompanyUnit(
        'companyUnit',
        [companyUnit.name],
        setOptions,
        allOptions,
        filters,
        setFilter,
        userCompanyUnits,
      );
    }
  }, [allOptions, companyUnit, filters, setFilter, userCompanyUnits]);

  // const companyUnitFilter = createSelectFilter('companyUnit', getCompanyUnitName(formatMessage), options?.companyUnits);
 const companyUnitFilter = createSelectFilter(
    'companyUnit',
    getCompanyUnitName(formatMessage),
    options?.companyUnits?.map(entityToSelectlebelOption),
    (option) => option.value.toString(),
    undefined,
    filters.companyUnit,
   disable?true:false,
  );
  // const areaFilter = createSelectFilter('area', formatMessage({ id: 'utils.filters.area' }), options?.areas);
  const areaFilter = createSelectFilter(
    'area',
    formatMessage({ id: 'utils.filters.area' }),
    options?.areas?.map(entityToSelectlebelOption),
    (option) => option.value.toString(),
    undefined,
    filters.area,
  );
  const complianceUsersFilter = createMultiSelectFilter(
    'complianceUsers',
    formatMessage({ id: 'utils.filters.complianceUsers' }),
    options?.complianceUsers,
    (option) => option.value?.toString(),
    undefined,
    filters.complianceUsers as string[],
  );

  const activeOption = { value: 1, label: formatMessage({ id: 'utils.filters.status.active' }) };

  const statusFilter = createSelectFilter(
    'status',
    formatMessage({ id: 'utils.filters.status' }),
    options?.statuses,
    (option) => option.value?.toString(),
    activeOption,
  );

  const processesFilter = createMultiSelectFilter(
    'processes',
    // formatMessage({ id: 'utils.filters.processes' }),
    getProcessName(formatMessage),
    options?.processes,
    (option) => option.value.toString(),
    undefined,
    filters.processes as string[],
  );

  const aspectsFilter = createMultiSelectFilter(
    'aspects',
    // formatMessage({ id: 'utils.filters.aspects' }),
    getAspectName(formatMessage),
    options?.aspects,
    (option) => option.value.toString(),
    undefined,
    filters.aspects as string[],
  );

  const tagsFilter = createMultiSelectFilter(
    'tags',
    // formatMessage({ id: 'utils.filters.tags' }),
    getTagName(formatMessage),
    options?.tags,
    (option) => option.value.toString(),
    undefined,
    filters.tags as string[],
  );

  return (
    <ListFilter
      filters={[
        companyUnitFilter,
        complianceUsersFilter,
        processesFilter,
        aspectsFilter,
        tagsFilter,
        areaFilter,
        statusFilter,
      ]}
      setFilter={onSetFilter}
    />
  );
};

